import React, { useEffect } from 'react';
import useAppStore from '../../store/appStore';

const INSIGHT_ICONS = {
  habit_detected: '🔄',
  goal_at_risk: '⚠️',
  correlation_found: '🔗',
  anomaly_detected: '📡',
  recommendation: '💡',
};

const INSIGHT_COLORS = {
  habit_detected: '#3b82f6',
  goal_at_risk: '#ef4444',
  correlation_found: '#8b5cf6',
  anomaly_detected: '#f59e0b',
  recommendation: '#10b981',
};

export default function InsightsFeed() {
  const insights = useAppStore(s => s.insights);
  const loadInsights = useAppStore(s => s.loadInsights);
  const dismissInsight = useAppStore(s => s.dismissInsight);

  useEffect(() => {
    loadInsights();
    const interval = setInterval(loadInsights, 60000);
    return () => clearInterval(interval);
  }, [loadInsights]);

  return (
    <div className="insights-feed">
      <div className="panel-header">
        <h2>Proactive Insights</h2>
        {insights.length > 0 && (
          <span className="badge badge-alert">{insights.length}</span>
        )}
      </div>

      {insights.length === 0 ? (
        <div className="empty-state">
          <p>No insights yet.</p>
          <p>ASI:Mind will surface patterns and correlations as your knowledge graph grows.
            The insight engine runs hourly.</p>
        </div>
      ) : (
        <div className="insights-list">
          {insights.map((insight, i) => (
            <InsightCard
              key={insight.name || i}
              insight={insight}
              onDismiss={() => dismissInsight(insight.name)}
            />
          ))}
        </div>
      )}
    </div>
  );
}

function InsightCard({ insight, onDismiss }) {
  const meta = insight.metadata || {};
  const insightType = meta.insight_type || 'recommendation';
  const confidence = meta.confidence || insight.truth_value?.confidence || 0;

  return (
    <div
      className="insight-card"
      style={{ borderLeft: `3px solid ${INSIGHT_COLORS[insightType] || '#64748b'}` }}
    >
      <div className="insight-header">
        <span className="insight-icon">{INSIGHT_ICONS[insightType] || '💡'}</span>
        <span
          className="insight-type"
          style={{ color: INSIGHT_COLORS[insightType] || '#94a3b8' }}
        >
          {insightType.replace('_', ' ')}
        </span>
        <span className="insight-confidence">{(confidence * 100).toFixed(0)}%</span>
        <button className="dismiss-btn" onClick={onDismiss} title="Dismiss">×</button>
      </div>

      <p className="insight-description">{meta.description}</p>

      {meta.supporting_atoms?.length > 0 && (
        <div className="insight-atoms">
          {meta.supporting_atoms.slice(0, 3).map((atom, i) => (
            <span key={i} className="atom-chip">{atom}</span>
          ))}
        </div>
      )}

      <div className="insight-ts">
        {meta.timestamp ? new Date(meta.timestamp).toLocaleString() : ''}
      </div>
    </div>
  );
}
